import { gql } from '@apollo/client';

export const GET_LOST_FOUND_ITEMS = gql`
  query GetLostFoundItems($page: Int!, $limit: Int!, $search: String, $propertyId: String, $status: LostFoundStatus, $category: LostFoundCategory, $isArchived: Boolean!) {
    lostFoundItems(page: $page, limit: $limit, search: $search, propertyId: $propertyId, status: $status, category: $category, isArchived: $isArchived) {
      items {
        id
        description
        photos
        trackingReceiptPhotos
        category
        status
        createdAt
        foundAt
        discardedAt
        shippedAt
        returnOfficeInstructions
        shippingAddress
        shippingContactName
        shippingContactEmail
        shippingContactPhone
        shippingCarrier
        trackingNumber
        ccOnFile
        isGuestSubmitted
        guestName
        guestEmail
        reservation {
          id
          streamline_reservation_id
          guest_name
          email
          mobile_phone
          check_in
          check_out
        }
        property {
          id
          name
          address
          city
          state
        }
        submitter {
          id
          firstName
          lastName
        }
        resolvedBy {
          id
          firstName
          lastName
        }
        foundBy {
          id
          firstName
          lastName
        }
        discardedBy {
          id
          firstName
          lastName
        }
        shippedBy {
          id
          firstName
          lastName
        }
        resolvedAt
      }
      total
      page
      limit
      totalPages
      hasMore
    }
  }
`;

export const GET_LOST_FOUND_ITEM = gql`
  query GetLostFoundItem($id: ID!) {
    lostFoundItem(id: $id) {
      id
      description
      photos
      trackingReceiptPhotos
      category
      status
      createdAt
      foundAt
      discardedAt
      shippedAt
      returnOfficeInstructions
      shippingAddress
      shippingContactName
      shippingContactEmail
      shippingContactPhone
      shippingCarrier
      trackingNumber
      ccOnFile
      isGuestSubmitted
      guestName
      guestEmail
      reservation {
        id
        streamline_reservation_id
        guest_name
        email
        mobile_phone
        check_in
        check_out
      }
      property {
        id
        name
        address
        city
        state
      }
      submitter {
        id
        firstName
        lastName
      }
      resolvedBy {
        id
        firstName
        lastName
      }
      foundBy {
        id
        firstName
        lastName
      }
      discardedBy {
        id
        firstName
        lastName
      }
      shippedBy {
        id
        firstName
        lastName
      }
      resolvedAt
    }
  }
`;

export const GET_LOST_FOUND_RESERVATION_CANDIDATES = gql`
  query GetLostFoundReservationCandidates($propertyId: ID!) {
    lostFoundReservationCandidates(propertyId: $propertyId) {
      id
      streamlineReservationId
      guestName
      checkIn
      checkOut
      isCurrent
      label
    }
  }
`;

export const CREATE_LOST_FOUND_ITEM = gql`
  mutation CreateLostFoundItem($input: CreateLostFoundInput!) {
    createLostFoundItem(createLostFoundInput: $input) {
      id
      description
      photos
      trackingReceiptPhotos
      category
      status
      trackingNumber
      property {
        id
        name
      }
    }
  }
`;

export const UPDATE_LOST_FOUND_ITEM = gql`
  mutation UpdateLostFoundItem($input: UpdateLostFoundInput!) {
    updateLostFoundItem(updateLostFoundInput: $input) {
      id
      category
      status
      trackingNumber
      shippingCarrier
      shippingContactEmail
      shippingContactPhone
      foundAt
      discardedAt
      shippedAt
    }
  }
`; 
